let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lSNP3")).then(() => parcelRequire('5EKtz'));